import Model from '@/core/models/Model';

export default class SupportRequirement1 extends Model {
  resource() {
    return 'app/servicesPaginateList';
  }
}
